import { getSelectOptionsFromString } from './Components/Select/Select';

export const AppRoles = getSelectOptionsFromString(['Admin', 'GlobalAdmin', 'User', 'GlobalSupport']);

export class AppRouting {
    public static Users = '/users';
    public static Organizations = '/organizations';
}

export class ApiURL {
    public static Condition = '/condition';
    public static Organizations = '/organizations';
    public static Users = '/users';
    public static ImportUsers = '/users/import';
    public static Subscriptions = '/subscriptions';
}

export enum Roles {
    GlobalAdmin = 'GlobalAdmin',
    Admin = 'Admin',
    User = 'User',
    GlobalSupport = 'GlobalSupport',
}